import Emitter from "tiny-emitter";
const EventBus = new Emitter();
export default EventBus;
